/**
 * This utility overrides the document.write method to safely handle content insertion in the Canvas App.
 */

/**
 * Inserts HTML content into the document without replacing the entire document
 * @param html - HTML content to insert
 */
const safeInsertHtml = (html: string): void => {
  try {
    // Create a document fragment from the HTML content
    const documentFragment = document
      .createRange()
      .createContextualFragment(html);

    // Insert the fragment at the current script position or at the end of body if no script context
    const currentScript = document.currentScript;

    if (currentScript && currentScript.parentNode) {
      currentScript.parentNode.insertBefore(
        documentFragment,
        currentScript.nextSibling
      );
    } else {
      // Fallback to appending to body if no current script context
      document.body.appendChild(documentFragment);
    }
  } catch (error) {
    console.error('Error in document.write override:', error);
  }
};

/**
 * Overrides the document.write method to safely handle content insertion
 */
export const overrideDocumentWrite = (): void => {
  // Override document.write with our safe implementation
  document.write = function (markup: string): void {
    safeInsertHtml(markup);
  };

  // Also override document.writeln for consistency
  document.writeln = function (markup: string): void {
    safeInsertHtml(markup + '\n');
  };
};
